module.exports = __webpack_public_path__ + "static/media/zip_code_database.02ee1279.csv";


//////////////////
// WEBPACK FOOTER
// ./src/zip_code_database.csv
// module id = 94
// module chunks = 0